import React from 'react';
import { useCityService } from '../services/city-service';

export const useCityController = () => {
  const { listCitiesByUf } = useCityService();
  const [listCities, setListCities] = React.useState({});
  const [rawCities, setRawCities] = React.useState([]);

  const getCitiesByUf = React.useCallback(
    (uf) => {
      if (!uf.id) {
        return setListCities({});
      }
      return listCitiesByUf(uf)
        .then((data) => {
          var listCities = data?.map((city) => ({
            id: city.id,
            label: city.name,
          }));
          setListCities((actualListCities) => ({
            ...actualListCities,
            [uf.id]: listCities,
          }));

          let cities = data
            .filter((city) => city.uf.id === JSON.parse(uf.id))
            .map((city) => ({
              id: city.id,
              label: city.name,
            }));
          setRawCities(cities);
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    [listCitiesByUf],
  );

  return {
    getCitiesByUf,
    listCities,
    rawCities,
  };
};
